
(function dynamicPaginatorModuleDefinition() {

    'use strict';

    angular.module('TranslatedPaginator', ['ui.bootstrap'])
        .directive('translatedPaginator', [
            function() {
                return {
                    require: ['?pagination', '?uibPagination'],
                    link: function(scope, ele, attrs, ctrls) {

                        if (ctrls[0]) {
                            console.warn('La directiva pagination está deprecada, utilice uib-pagination');
                        } else if (!ctrls[1]) {
                            console.error('La directiva translated-paginator se debe utilizar con la directiva uib-pagination');
                        }

                        scope.$watch(attrs.translatedPaginator, function(value) {
                            if (value)
                                (ctrls[0] || ctrls[1]).config = value;
                        });

                    }
                };
            }
        ]);
})();